import { AgentInterface } from '../Agent/Agent.Model'
import { TenantInfo } from '../FMS/FMS.Interfaces'

interface CampaignTaskResponse {
  status: TaskStatus
  message?: string
  taskId: string
}

interface CampaignActiveTenantsResponse {
  status: string
  taskId: string
  tenants: LocationTenantsMap
}

interface TaskResponseInterface {
  status: TaskStatus
  message?: string
}

interface StartTaskBodyInterface {
  facilities: Facility[]
  agent: Partial<AgentInterface>
}

interface ProcessUsersBodyInterface {
  message: string
  questSlug: string
  selectedTenants: LocationTenantsMap
  agent: Partial<AgentInterface>
}

enum TaskStatus {
  PENDING = 'pending',
  STARTED = 'started',
  COMPLETED = 'completed',
  FAILED = 'failed'
}

interface Facility {
  facilityId: string
  storeLocationNumber: string
}

type SelectedTenants = {
  [phoneNumber: string]: TenantInfo[]
}

type LocationTenantsMap = {
  [locationNumber: string]: SelectedTenants
}

export {
  CampaignTaskResponse,
  TaskStatus,
  Facility,
  SelectedTenants,
  LocationTenantsMap,
  StartTaskBodyInterface,
  ProcessUsersBodyInterface,
  CampaignActiveTenantsResponse,
  TaskResponseInterface
}
